// Contact form — submission feedback handling.
//
// The classic POST → admin-post.php → redirect-with-?contact=sent flow
// leaves the success/error banner pinned to the page forever, which
// makes it look like the form failed to clear. Auto-dismiss after a
// few seconds and strip the query param from the URL so a refresh
// doesn't bring the banner back.
const STATUS = new URLSearchParams(window.location.search).get('contact');
const NOTICE = document.querySelector('[data-contact-notice]');
const FORM   = document.querySelector('.contact-form');

if (NOTICE) {
    // Fade + collapse after 5s so the page goes back to a clean state.
    setTimeout(() => {
        NOTICE.style.transition = 'opacity 320ms ease, transform 320ms ease, max-height 320ms ease, margin 320ms ease, padding 320ms ease';
        NOTICE.style.opacity = '0';
        NOTICE.style.transform = 'translateY(-6px)';
        NOTICE.style.maxHeight = '0';
        NOTICE.style.marginBlockEnd = '0';
        NOTICE.style.paddingBlock = '0';
        NOTICE.style.overflow = 'hidden';
        setTimeout(() => NOTICE.remove(), 360);
    }, 5000);
}

// Reset the form on a successful submit so the inputs return to their
// pristine state (helpful if the user lingers on the page).
if (FORM && STATUS === 'sent') {
    FORM.reset();
}

// Strip ?contact=… from the URL after we've used the value above, so a
// refresh doesn't re-trigger the banner / reset.
if (STATUS && window.history && history.replaceState) {
    const url = new URL(window.location.href);
    url.searchParams.delete('contact');
    history.replaceState({}, document.title, url.pathname + url.search + url.hash);
}
